import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import { ArrowBack } from "@material-ui/icons";
import { Box, Typography } from "@material-ui/core";
import { useStyles } from "./indexStyles";
import { getStorageItem } from "../../helpers/utils";
import { PRODUCT_NAME } from "../../constants/index";

function SubHeader(props) {
  const {
    bgColor = "dark", //'light',
    color = "light", //'dark',
    classes: {
      backStep,
      bgColorDark,
      bgColorLight,
      colorDark,
      colorLight,
      headerBox,
      headerBoxContainer,
      headerText,
    },
    onClick,
    isBackButtonVisible = true,
    title = getStorageItem(PRODUCT_NAME),
  } = props;

  return (
    <Box className={headerBoxContainer}>
      <Box
        className={`${headerBox} ${
          bgColor === "dark" ? bgColorDark : bgColorLight
        }`}
      >
        {isBackButtonVisible && (
          <Box
            className={`${backStep} ${
              color === "dark" ? colorDark : colorLight
            }`}
            onClick={onClick}
          >
            <ArrowBack />
          </Box>
        )}
        <Box className={headerText}>
          <Typography
            variant={"h4"}
            gutterBottom
            className={`${headerText} ${
              color === "dark" ? colorDark : colorLight
            }`}
          >
            {title}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(SubHeader);
